import { colors } from "themes/palette/colors"

// TODO: once approved — move scrollbarStyles into muiCssBaseline global override
// and add import in themes/components/index.ts to apply app-wide
export const SCROLLBAR_WIDTH = 3

export const scrollbarStyles = {
  "&::-webkit-scrollbar": { width: `${SCROLLBAR_WIDTH}px` },
  "&::-webkit-scrollbar-track": {
    background: colors.primary95,
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: colors.primary60,
    borderRadius: "8px",
    transition: "background 0.25s ease",
  },
  "&::-webkit-scrollbar-thumb:hover": { background: colors.primary_base },
  scrollbarWidth: "thin" as const,
  scrollbarColor: `${colors.primary60} ${colors.primary95}`,
}
